import { checkoutApi } from './checkoutApi';
import { paymentApi } from '../common/payment/paymentApi';
import { userInfoApi } from '../common/userInfo/userInfoApi';
import { offerApi } from '../common/offers/offerApi';
import { make3dsApi } from '../common/make3ds/make3dsApi';
import { logTrackApi } from '../common/logTrack/logTrackApi';
import commonReducers from '../../slices';

const middleware = [ checkoutApi.middleware, paymentApi.middleware,
  userInfoApi.middleware, offerApi.middleware, make3dsApi.middleware, logTrackApi.middleware ];

const apiReducers = {
  [checkoutApi.reducerPath]: checkoutApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [userInfoApi.reducerPath]: userInfoApi.reducer,
  [make3dsApi.reducerPath]: make3dsApi.reducer,
  [offerApi.reducerPath]: offerApi.reducer,
  [logTrackApi.reducerPath]: logTrackApi.reducer,
  ...commonReducers,
};

export { middleware, apiReducers };
export default checkoutApi;
